import React from 'react';
import { Icon } from '@web-chat-core/ui-kit';
import { RaiseHandIconWrapper } from './view';

interface RaiseHandIconProps {
    size?: number;
}

const DEFAULT_SIZE = 24;

export const RaiseHandIcon = ({ size = DEFAULT_SIZE }: RaiseHandIconProps) => {
    return (
        <RaiseHandIconWrapper $size={size}>
            <Icon icon="icHandUp" size={size} colorVariant="basic" />
        </RaiseHandIconWrapper>
    );
};
